var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('div',{ref:"container",class:['player-area-inner-trailer', {'active': _vm.isPlaying }],attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }